<template>
  <!-- NOTE (TEMPLATE) to show & edit reasercher profile -->

  <div class="animated fadeIn">
    <span v-show="false">{{ reactivity }}</span>
    <!-- loading component -->
    <Loading />

    <!-- reset pass  -->
    <b-modal
      id="resetPassModal"
      ref="resetPassModal"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center"
      size="md"
      centered
    >
      <template v-slot:modal-header>
        <h4>بازیابی رمز عبور</h4>
      </template>
      <template v-slot:modal-footer>
        <b-button
          variant="danger"
          size="lg"
          class="ml-2"
          @click="closeResetPass()"
          >لغو</b-button
        >
      </template>
      <div class="container" v-if="role == 'researcher' || role == 'referee'">
        <b-row class="justify-content-center">
          <b-col md="10">
            <p>
              لطفا کدی را که اکنون به شما پیامک کردیم را به همراه رمز عبور جدید
              وارد نمایید
            </p>
            <b-input-group class="mb-4">
              <b-input-group-prepend>
                <b-input-group-text>
                  <i class="icon-lock"></i>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                trim
                type="number"
                :no-wheel="true"
                v-model="activationCode"
                class="form-control"
                placeholder="کد ارسالی"
              />
            </b-input-group>
            <b-input-group class="mb-4">
              <b-input-group-prepend>
                <b-input-group-text>
                  <i class="icon-lock"></i>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                trim
                type="password"
                @input="passStrength"
                v-model="newPass"
                class="form-control"
                placeholder="رمز عبور جدید"
              />
            </b-input-group>
            <!--============== checking password =========== -->
            <b-row>
              <b-col>
                <!-- NOTE check if the pass has more than 8 charector -->
                <p class="pass" :class="{ 'pass--passed': newPass.length > 7 }">
                  <i
                    class="frmIcon fa"
                    :class="newPass.length > 7 ? 'fa-check' : 'fa-times'"
                  ></i>
                  حداقل ۸ نویسه
                </p>
              </b-col>
              <b-col>
                <!-- NOTE check if the pass has uppercase -->
                <p class="pass" :class="{ 'pass--passed': rec_has_uppercase }">
                  <i
                    class="frmIcon fa"
                    :class="rec_has_uppercase ? 'fa-check' : 'fa-times'"
                  ></i>
                  دارای حروف بزرگ باشد
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <!-- NOTE check if the pass has lowercase -->
                <p class="pass" :class="{ 'pass--passed': rec_has_lowercase }">
                  <i
                    class="frmIcon fa"
                    :class="rec_has_lowercase ? 'fa-check' : 'fa-times'"
                  ></i>
                  دارای حروف کوچک باشد
                </p>
              </b-col>
              <b-col>
                <!-- NOTE check if the pass has number -->
                <p class="pass" :class="{ 'pass--passed': rec_has_number }">
                  <i
                    class="frmIcon fa"
                    :class="rec_has_number ? 'fa-check' : 'fa-times'"
                  ></i>
                  دارای عدد باشد
                </p>
              </b-col>
            </b-row>

            <!--============== checking password =========== -->
            <b-input-group class="mb-4">
              <b-input-group-prepend>
                <b-input-group-text>
                  <i class="icon-lock"></i>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                trim
                type="password"
                v-model="repeatNewPass"
                class="form-control"
                placeholder="تکرار رمز عبور جدید"
              >
              </b-form-input>
            </b-input-group>
            <b-row>
              <b-col cols="6">
                <!-- NOTE (b-login) to go to the researcher dashboard -->
                <b-button
                  type="submit"
                  variant="primary"
                  @click="resetPass()"
                  style="border: 0"
                  :disabled="
                    busy || !(repeatNewPass && newPass && activationCode)
                  "
                >
                  <i class="icon-login"></i>تغییر رمز </b-button
                >&nbsp;
              </b-col>
              <b-col cols="6" class="text-left">
                <!-- NOTE (b-sendAgain) to get the activation code again -->
                <b-button
                  type="submit"
                  variant="info"
                  @click="sendCode()"
                  style="border: 0"
                  :disabled="sendAgainDisbaled"
                >
                  <b-icon icon="arrow-counterclockwise"></b-icon>ارسال مجدد کد
                  <span v-if="countdown != 0">{{ toHHMMSS(countdown) }}</span>
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <!-- reset pass  -->

    <b-card style="border: 0" class="mt-0 mb-0">
      <b-card
        v-if="profile.adminMessage && role == 'researcher'"
        header-bg-variant="danger"
        header-text-variant="white"
        header="هشدارها"
        style="border: 0"
        class="shadow p-3 mb-5 bg-white rounded mt-0"
        >{{ profile.adminMessage }}</b-card
      >
      <b-tabs pills>
        <b-tab v-if="role == 'researcher'" :title="'اطلاعات فردی'" active>
          <h5 class="text-info">وضعیت حساب کاربری: {{ profile.status }}</h5>
          <hr />

          <!-- <b-form-group label="وضعیت حساب کاربری">
            <b-form-input trim  type="text" v-model="profile.status" disabled></b-form-input>
          </b-form-group>-->
          <div v-if="profile.isDistinguished">
            <div
              class="img-box pointer"
              @click="$refs.profileImage.$refs.input.click()"
            >
              <img
                height="150"
                width="150"
                class="img"
                :src="
                  profile.avatar
                    ? profile.avatar
                    : 'https://www.sibberhuuske.nl/wp-content/uploads/2016/10/default-avatar-300x300.png'
                "
              />
              <v-icon x-large class="img-icon white--text">mdi-camera</v-icon>
              <div class="img-loading" v-if="profileLoading">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  :size="40"
                ></v-progress-circular>
                <span class="mt-4">در حال بارگذاری... </span>
              </div>
            </div>
            <!--<div
              class="uploadPercentage"
              v-if="
                myImageFile.uploadPercentage != 0 &&
                myImageFile.uploadPercentage != 100
              "
            >
              <span>{{ myImageFile.uploadPercentage }}%</span>
            </div>-->
            <v-file-input
              v-show="false"
              @change="uploadProfile(imageFile)"
              v-model="imageFile"
              ref="profileImage"
            ></v-file-input>
          </div>

          <b-row>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
              <b-col>
                <b-form-group label="نام">
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="fa fa-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>

                    <b-form-input
                      trim
                      type="text"
                      v-model="profile.name"
                      class="form-control"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
              <b-col>
                <b-form-group label="نام خانوادگی">
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="fa fa-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>

                    <b-form-input
                      trim
                      type="text"
                      v-model="profile.lastName"
                      class="form-control"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <b-col>
                <b-form-group
                  label="کدملی"
                  type="number"
                  :no-wheel="true"
                  v-model="profile.natCode"
                  invalid-feedback="کد ملی درست نیست"
                  :state="isID(profile.natCode)"
                >
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="fa fa-id-card-o"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>

                    <b-form-input
                      trim
                      type="number"
                      :no-wheel="true"
                      v-model="profile.natCode"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </div>
          </b-row>

          <b-row>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
              <b-col>
                <b-form-group label="تلفن همراه">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-mobile"></i>
                    </b-input-group-text>
                    <b-form-input
                      trim
                      type="number"
                      :no-wheel="true"
                      v-model="profile.mobile"
                      disabled
                    ></b-form-input>
                  </b-input-group-prepend>
                </b-form-group>
              </b-col>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
              <b-col>
                <b-form-group label="تلفن منزل">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-phone"></i>
                    </b-input-group-text>
                    <b-form-input
                      trim
                      type="text"
                      v-model="profile.homePhone"
                    ></b-form-input>
                  </b-input-group-prepend>
                </b-form-group>
              </b-col>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <b-col>
                <b-form-group label="تلفن محل کار">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-phone-square"></i>
                    </b-input-group-text>
                    <b-form-input
                      trim
                      type="text"
                      v-model="profile.officePhone"
                    ></b-form-input>
                  </b-input-group-prepend>
                </b-form-group>
              </b-col>
            </div>
          </b-row>
          <b-row>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
              <b-col>
                <b-row class="other-row">
                  <b-col>
                    <span class="select-text">دانشگاه محل اشتغال</span>
                  </b-col>
                  <b-col class="text-left">
                    <b-form-checkbox
                      id="checkbox-1"
                      v-model="profile.universityJobId"
                      name="checkbox-1"
                      value="1"
                      unchecked-value=""
                      @change="reactivity = !reactivity"
                    >
                      سایر دانشگاه ها
                    </b-form-checkbox>
                  </b-col>
                </b-row>
                <b-form-group>
                  <!-- <b-form-input trim  type="text" v-model="profile.city"></b-form-input> -->
                  <b-input-group-prepend>
                    <b-input-group-text style="height: 28px">
                      <i class="fa fa-university"></i>
                    </b-input-group-text>
                    <b-form-group style="width: 100%">
                      <Select2
                        v-model="profile.universityJobId"
                        :options="universityList"
                        @select="conditionalSelect($event, 'job')"
                        :settings="{ width: '100%' }"
                        :disabled="profile.universityJobId == 1"
                      ></Select2>
                      <b-form-input
                        trim
                        class="mt-1"
                        v-model="profile.universityJobOther"
                        v-show="profile.universityJobId == 1"
                        placeholder="نام دانشگاه"
                        @input="reactivity = !reactivity"
                      ></b-form-input> </b-form-group
                    ><b-button
                      style="height: 28px"
                      class="bg-danger ms-1"
                      :disabled="!profile.universityJobId"
                      @click="delUni()"
                      ><i class="fa fa-trash white--text"></i
                    ></b-button>
                  </b-input-group-prepend>
                </b-form-group>
              </b-col>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
              <b-col>
                <b-row class="other-row">
                  <b-col>
                    <span class="select-text">دانشگاه محل تحصیل</span>
                  </b-col>
                  <b-col class="text-left">
                    <b-form-checkbox
                      id="checkbox-2"
                      v-model="profile.universityId"
                      name="checkbox-2"
                      :value="notUniversity"
                      unchecked-value=""
                      @change="reactivity = !reactivity"
                    >
                      سایر دانشگاه ها
                    </b-form-checkbox>
                  </b-col>
                </b-row>
                <b-form-group>
                  <!-- <b-form-input trim  type="text" v-model="profile.city"></b-form-input> -->
                  <b-input-group-prepend>
                    <b-input-group-text style="height: 28px">
                      <i class="fa fa-university"></i>
                    </b-input-group-text>
                    <b-form-group style="width: 100%">
                      <Select2
                        class="myselect2"
                        v-model="profile.universityId"
                        :options="universityList"
                        @select="conditionalSelect($event, 'edu')"
                        :disabled="profile.universityId == notUniversity"
                        :settings="{ width: '100%' }"
                      ></Select2>
                      <b-form-input
                        trim
                        class="mt-1"
                        v-model="profile.universityOther"
                        v-show="profile.universityId == notUniversity"
                        placeholder="نام دانشگاه"
                        @input="reactivity = !reactivity"
                      ></b-form-input
                    ></b-form-group>
                  </b-input-group-prepend>
                </b-form-group>
              </b-col>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <b-col>
                <b-form-group label="آخرین مدرک تحصیلی">
                  <!-- <b-form-input trim  type="text" v-model="profile.city"></b-form-input> -->
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-book"></i>
                    </b-input-group-text>
                    <b-form-select
                      v-model="profile.lastDegree"
                      :options="eduGradeOptions"
                      @select="conditionalSelect($event, 'last')"
                    ></b-form-select>
                  </b-input-group-prepend>
                </b-form-group>
              </b-col>
            </div>
          </b-row>
          <b-row>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <b-col>
                <b-form-group label="دورنگار">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-fax"></i>
                    </b-input-group-text>
                    <b-form-input
                      trim
                      type="text"
                      v-model="profile.fax"
                    ></b-form-input>
                  </b-input-group-prepend>
                </b-form-group>
              </b-col>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <b-col>
                <b-form-group
                  invalid-feedback="پست الکترونیکی درست نیست"
                  :state="isEmail(profile.email)"
                  label="پست الکترونیکی"
                >
                  <!-- <b-form-input trim  type="text" v-model="profile.city"></b-form-input> -->
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-envelope"></i>
                    </b-input-group-text>
                    <b-form-input
                      trim
                      type="text"
                      v-model="profile.email"
                    ></b-form-input>
                  </b-input-group-prepend>
                  <b-form-invalid-feedback
                    id="input-1-live-feedback"
                  ></b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <b-col>
                <b-form-group label="آدرس صفحه شخصی">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <v-icon small>mdi-web</v-icon>
                    </b-input-group-text>
                    <b-form-input
                      trim
                      type="text"
                      v-model="profile.website"
                    ></b-form-input>
                  </b-input-group-prepend>
                </b-form-group>
              </b-col>
            </div>
          </b-row>

          <b-row>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
              <b-col>
                <b-form-group label="استان">
                  <!-- <b-form-input trim  type="text" v-model="profile.city"></b-form-input> -->
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-map-marker"></i>
                    </b-input-group-text>
                    <v-autocomplete
                      v-model="profile.stateId"
                      :items="iran"
                      @change="profile.cityId = ''"
                      item-value="id"
                      item-text="name"
                      dense
                      outlined
                      class="dropdown-style ms-2"
                      hide-details
                    ></v-autocomplete>
                  </b-input-group-prepend>
                </b-form-group>
              </b-col>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
              <b-col>
                <b-form-group label="شهر">
                  <!-- <b-form-input trim  type="text" v-model="profile.city"></b-form-input> -->
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-map-marker"></i>
                    </b-input-group-text>
                    <v-autocomplete
                      v-model="profile.cityId"
                      :items="
                        iran
                          .filter((x) => x.id == profile.stateId)
                          .map((y) => y.cities)[0]
                      "
                      item-value="id"
                      item-text="name"
                      dense
                      outlined
                      class="dropdown-style ms-2"
                      hide-details
                    ></v-autocomplete>
                  </b-input-group-prepend>
                </b-form-group>
              </b-col>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <b-col class="p-0">
                <b-input-group-prepend class="mb-1">
                  <b-input-group-text>
                    <span class="mr-2">آدرس منزل</span>
                    <i class="fa fa-map-marker"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-group>
                  <b-form-textarea
                    trim
                    type="text"
                    v-model="profile.address"
                    rows="6"
                    max-rows="8"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </div>
          </b-row>
          <hr />
          <b-form-group
            label="موضوع فعالیت زیست فناوری"
            v-if="profile.isDistinguished"
          >
            <v-autocomplete
              v-model="profile.catId"
              :items="categories"
              item-value="code"
              item-text="label"
              dense
              outlined
              class="dropdown-style mb-4"
              hide-details
            ></v-autocomplete>
          </b-form-group>
          <b-form-group label>
            <h5 class="text-info">
              مدارج تحصیلی و تخصصی ( كارشناسی و بالاتر ):
            </h5>
            <br />
            <b-button variant="success" class="mb-1" @click="addOffer()"
              >+</b-button
            >
            <!-- NOTE (degreesTable) to add Educational and professional qualifications -->
            <b-table
              responsive
              small
              show-empty
              head-variant="dark"
              :items="items"
              :fields="eduFields"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
              <template v-slot:cell(customerIndex)="data">
                <b-form-input
                  trim
                  v-model="data.item.customerIndex"
                  type="text"
                ></b-form-input>
              </template>
              <template v-slot:cell(operation)="data">
                <!-- NOTE (b-delOffer) to remove a row from degrees table -->
                <b-button
                  variant="danger"
                  class="mr-2"
                  @click="delOffer(data.item, data.index)"
                  >x</b-button
                >
              </template>

              <template v-slot:cell(eduGrade)="data">
                <b-form-select
                  class="myselect2"
                  id="second"
                  v-model="data.item.eduGrade"
                  :options="eduGradeOptions"
                  :settings="{ width: '100%' }"
                ></b-form-select>
                <!-- </div> -->
              </template>

              <template v-slot:cell(eduField)="data">
                <b-form-input
                  trim
                  v-model="data.item.eduField"
                  type="text"
                  rows="6"
                  max-rows="6"
                ></b-form-input>
              </template>
              <template v-slot:cell(uniName)="data">
                <b-form-input
                  trim
                  v-model="data.item.uniName"
                  type="text"
                  rows="6"
                  max-rows="6"
                ></b-form-input>
              </template>
              <template v-slot:cell(country)="data">
                <!-- <b-form-input trim  v-model="data.item.country" type="text" rows="6" max-rows="6"></b-form-input> -->
                <Select2
                  v-model="data.item.country"
                  :options="countries.map((x) => x.fa)"
                  :settings="{ width: '100%' }"
                ></Select2>
              </template>

              <template v-slot:cell(year)="data">
                <!-- <b-form-input trim  v-model="data.item.year" type="text"></b-form-input> -->
                <span v-show="false">{{ eduReactivity }}</span>
                <b-form-input
                  trim
                  v-model="data.item.year"
                  type="text"
                  rows="6"
                  max-rows="6"
                  @click="
                    showYearModal[data.index] = true;
                    selectedIndex = data.index;
                    eduReactivity = !eduReactivity;
                  "
                  class="pointer"
                ></b-form-input>
                <year-modal
                  v-if="showYearModal[data.index]"
                  :chosenYear="data.item.year"
                  @dialogYear="getItemYear"
                  @showModal="getShowModal"
                ></year-modal>
                <!-- <div slot="label">سال</div> -->
              </template>
            </b-table>
          </b-form-group>
          <hr />

          <div v-if="profile.isDistinguished">
            <h5 class="text-info mb-0">
              شرح فعالیت‌های انجام گرفته در زیست فناوری:
            </h5>
            <br />
            <vue-ckeditor v-model="profile.doneActivities" :config="config" />
            <hr class="mt-10" />

            <h5 class="text-info mb-0">
              شرح فعالیت‌های در دست انجام و برنامه ریزی شده:
            </h5>
            <br />
            <vue-ckeditor
              v-model="profile.inProgressActivities"
              :config="config"
            />
            <hr />
            <br />

            <h5 class="text-info mb-0">مقالات حوزه زیست فناوری:</h5>
            <br />
            <b-button
              variant="success"
              class="mb-1"
              @click="addItem('articles')"
              >+</b-button
            >
            <!-- NOTE (degreesTable) to add Educational and professional qualifications -->
            <b-table
              responsive
              small
              show-empty
              head-variant="dark"
              :items="articles"
              :fields="articlesFields"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
              <template v-slot:cell(title)="data">
                <b-form-input
                  trim
                  v-model="data.item.title"
                  type="text"
                ></b-form-input>
              </template>
              <template v-slot:cell(DOI)="data">
                <span v-show="false">
                  {{ reactivity }}
                </span>
                <b-input-group>
                  <template #append>
                    <div class="px-2">
                      <div class="pt-1" v-if="doiLoading[data.index]">
                        <v-progress-circular
                          indeterminate
                          color="primary"
                          :size="25"
                        ></v-progress-circular>
                      </div>
                      <div
                        class="pt-2"
                        v-else-if="
                          !doiLoading[data.index] &&
                          !wrongDoi[data.index] &&
                          haveChar[data.index]
                        "
                      >
                        <v-icon class="green--text">mdi-check-circle</v-icon>
                      </div>
                      <div
                        class="pt-2"
                        v-else-if="
                          !doiLoading[data.index] &&
                          wrongDoi[data.index] &&
                          haveChar[data.index]
                        "
                      >
                        <v-icon class="red--text">mdi-close-circle</v-icon>
                      </div>
                    </div>
                  </template>
                  <b-form-input
                    trim
                    v-model="data.item.DOI"
                    type="text"
                    :style="
                      !doiLoading[data.index] &&
                      wrongDoi[data.index] &&
                      haveChar[data.index]
                        ? 'border: 1px solid red'
                        : ''
                    "
                    @input="checkDoi(data.item.DOI, data.index)"
                  ></b-form-input>
                </b-input-group>
                <span
                  class="fs-xsmall red--text px-1"
                  dir="ltr"
                  v-if="
                    !doiLoading[data.index] &&
                    wrongDoi[data.index] &&
                    haveChar[data.index]
                      ? 'border: 1px solid red'
                      : ''
                  "
                  >{{ errorMessage[data.index] }}</span
                >
              </template>
              <template v-slot:cell(operation)="data">
                <!-- NOTE (b-delOffer) to remove a row from degrees table -->
                <div class="text-center">
                  <b-button
                    variant="danger"
                    class="mx-auto"
                    @click="delItem('articles', data.item, data.index)"
                    >x</b-button
                  >
                </div>
              </template>

              <template v-slot:cell(publishDate)="data">
                <!-- <b-form-input trim  v-model="data.item.year" type="text"></b-form-input> -->
                <date-picker
                  color="#7b1fa2"
                  v-model="data.item.publishDate"
                  :auto-submit="true"
                  :editable="true"
                  :show="false"
                >
                  <!-- <div slot="label">سال</div> -->
                </date-picker>
              </template>
            </b-table>
            <hr />
            <br />

            <h5 class="text-info mb-0">اختراعات به ثبت رسیده در این حوزه:</h5>
            <br />
            <b-button
              variant="success"
              class="mb-1"
              @click="addItem('inventions')"
              >+</b-button
            >
            <!-- NOTE (degreesTable) to add Educational and professional qualifications -->
            <b-table
              responsive
              small
              show-empty
              head-variant="dark"
              :items="inventions"
              :fields="inventionsFields"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
              <template v-slot:cell(title)="data">
                <b-form-input
                  trim
                  v-model="data.item.title"
                  type="text"
                ></b-form-input>
              </template>
              <template v-slot:cell(operation)="data">
                <!-- NOTE (b-delOffer) to remove a row from degrees table -->
                <div class="text-center">
                  <b-button
                    variant="danger"
                    class="mx-auto"
                    @click="delItem('inventions', data.item, data.index)"
                    >x</b-button
                  >
                </div>
              </template>

              <template v-slot:cell(submitDate)="data">
                <!-- <b-form-input trim  v-model="data.item.year" type="text"></b-form-input> -->
                <date-picker
                  color="#7b1fa2"
                  v-model="data.item.submitDate"
                  :auto-submit="true"
                  :editable="true"
                  :show="false"
                >
                  <!-- <div slot="label">سال</div> -->
                </date-picker>
              </template>
            </b-table>
            <hr />
            <br />

            <h5 class="text-info mb-0">کتاب‌های به چاپ رسیده:</h5>
            <br />
            <b-button variant="success" class="mb-1" @click="addItem('books')"
              >+</b-button
            >
            <!-- NOTE (degreesTable) to add Educational and professional qualifications -->
            <b-table
              responsive
              small
              show-empty
              head-variant="dark"
              :items="books"
              :fields="booksFields"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
              <template v-slot:cell(title)="data">
                <b-form-input
                  trim
                  v-model="data.item.title"
                  type="text"
                ></b-form-input>
              </template>
              <template v-slot:cell(publisher)="data">
                <b-form-input
                  trim
                  v-model="data.item.publisher"
                  type="text"
                ></b-form-input>
              </template>
              <template v-slot:cell(operation)="data">
                <!-- NOTE (b-delOffer) to remove a row from degrees table -->
                <div class="text-center">
                  <b-button
                    variant="danger"
                    class="mx-auto"
                    @click="delItem('books', data.item, data.index)"
                    >x</b-button
                  >
                </div>
              </template>

              <template v-slot:cell(publishDate)="data">
                <!-- <b-form-input trim  v-model="data.item.year" type="text"></b-form-input> -->
                <date-picker
                  color="#7b1fa2"
                  v-model="data.item.publishDate"
                  :auto-submit="true"
                  :editable="true"
                  :show="false"
                >
                  <!-- <div slot="label">سال</div> -->
                </date-picker>
              </template>
            </b-table>
            <hr />
            <br />

            <h5 class="text-info mb-0">گرنت‌های دریافت شده:</h5>
            <br />
            <b-button variant="success" class="mb-1" @click="addItem('grants')"
              >+</b-button
            >
            <!-- NOTE (degreesTable) to add Educational and professional qualifications -->
            <b-table
              responsive
              small
              show-empty
              head-variant="dark"
              :items="grants"
              :fields="grantFields"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
              <template v-slot:cell(title)="data">
                <b-form-input
                  trim
                  v-model="data.item.title"
                  type="text"
                ></b-form-input>
              </template>
              <template v-slot:cell(subject)="data">
                <b-form-input
                  trim
                  v-model="data.item.subject"
                  type="text"
                ></b-form-input>
              </template>
              <template v-slot:cell(operation)="data">
                <!-- NOTE (b-delOffer) to remove a row from degrees table -->
                <div class="text-center">
                  <b-button
                    variant="danger"
                    class="mx-auto"
                    @click="delItem('grants', data.item, data.index)"
                    >x</b-button
                  >
                </div>
              </template>

              <template v-slot:cell(grantYear)="data">
                <span v-show="false">{{ eduReactivity }}</span>
                <b-form-input
                  trim
                  v-model="data.item.grantYear"
                  type="text"
                  rows="6"
                  max-rows="6"
                  @click="
                    showGrantYearModal[data.index] = true;
                    selectedGrantIndex = data.index;
                    eduReactivity = !eduReactivity;
                  "
                  class="pointer"
                ></b-form-input>
                <year-modal
                  v-if="showGrantYearModal[data.index]"
                  :chosenYear="data.item.grantYear"
                  @dialogYear="getGrantYear"
                  @showModal="getShowGrantModal"
                ></year-modal>
              </template>
            </b-table>
          </div>

          <div>
            <!-- NOTE (b-submit) to submit and save uploaded files -->
            <v-btn
              :disabled="busySave || hasWrongDoi || hasloading"
              @click="submit()"
              class="mt-5 green-btn"
            >
              <v-icon class="me-2">mdi-check</v-icon>

              ذخیره اطلاعات
            </v-btn>
          </div>
        </b-tab>
        <b-tab v-if="role == 'referee'" :title="'اطلاعات فردی'" active>
          <h5 class="text-info">وضعیت حساب کاربری: {{ profile.status }}</h5>
          <hr />
          <form autocomplete="off">
            <b-row>
              <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                <b-col>
                  <b-form-group label="نام">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="fa fa-user"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>

                      <b-form-input
                        trim
                        type="text"
                        v-model="profile.name"
                        class="form-control"
                      />
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                <b-col>
                  <b-form-group label="نام خانوادگی">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="fa fa-user"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>

                      <b-form-input
                        trim
                        type="text"
                        v-model="profile.lastName"
                        class="form-control"
                      />
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <b-col>
                  <b-form-group
                    label="کدملی"
                    type="number"
                    :no-wheel="true"
                    v-model="profile.natCode"
                    aria-describedby="input-1-live-feedback"
                    :state="isID(profile.natCode)"
                  >
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="fa fa-id-card-o"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-invalid-feedback id="input-1-live-feedback"
                        >کد ملی درست نیست</b-form-invalid-feedback
                      >
                      <b-form-input
                        trim
                        type="number"
                        :no-wheel="true"
                        v-model="profile.natCode"
                        aria-describedby="input-1-live-feedback"
                        :state="isID(profile.natCode)"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </div>
            </b-row>
            <b-row>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <b-col>
                  <b-form-group label="تلفن همراه">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="fa fa-mobile"></i>
                      </b-input-group-text>
                      <b-form-input
                        trim
                        type="number"
                        :no-wheel="true"
                        v-model="profile.mobile"
                        disabled
                      ></b-form-input>
                    </b-input-group-prepend>
                  </b-form-group>
                </b-col>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <b-col>
                  <b-form-group label="پست الکترونیکی">
                    <!-- <b-form-input trim  type="text" v-model="profile.city"></b-form-input> -->
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="fa fa-envelope"></i>
                      </b-input-group-text>
                      <b-form-input
                        trim
                        type="text"
                        v-model="profile.email"
                        aria-describedby="input-1-live-feedback"
                        :state="isEmail(profile.email)"
                      ></b-form-input>
                    </b-input-group-prepend>
                    <b-form-invalid-feedback id="input-1-live-feedback"
                      >پست الکترونیکی درست نیست</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
              </div>
            </b-row>
            <b-row>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <b-col>
                  <b-form-group label="استان">
                    <!-- <b-form-input trim  type="text" v-model="profile.city"></b-form-input> -->
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="fa fa-map-marker"></i>
                      </b-input-group-text>
                      <v-autocomplete
                        v-model="profile.stateId"
                        :items="iran"
                        @change="profile.cityId = ''"
                        item-value="id"
                        item-text="name"
                        dense
                        outlined
                        class="dropdown-style ms-2"
                        hide-details
                      ></v-autocomplete>
                    </b-input-group-prepend>
                  </b-form-group>
                </b-col>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <b-col>
                  <b-form-group label="شهر">
                    <!-- <b-form-input trim  type="text" v-model="profile.city"></b-form-input> -->
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="fa fa-map-marker"></i>
                      </b-input-group-text>
                      <v-autocomplete
                        v-model="profile.cityId"
                        :items="
                          iran
                            .filter((x) => x.id == profile.stateId)
                            .map((y) => y.cities)[0]
                        "
                        item-value="id"
                        item-text="name"
                        dense
                        outlined
                        class="dropdown-style ms-2"
                        hide-details
                      ></v-autocomplete>
                    </b-input-group-prepend>
                  </b-form-group>
                </b-col>
              </div>
            </b-row>
            <b-row>
              <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                <b-col>
                  <b-row class="other-row">
                    <b-col>
                      <span class="select-text">دانشگاه محل تحصیل</span>
                    </b-col>
                    <b-col class="text-left">
                      <b-form-checkbox
                        id="checkbox-3"
                        v-model="profile.universityId"
                        name="checkbox-3"
                        :value="notUniversity"
                        unchecked-value=""
                        @change="reactivity = !reactivity"
                      >
                        سایر دانشگاه ها
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                  <b-form-group>
                    <b-input-group-prepend>
                      <b-input-group-text style="height: 28px">
                        <i class="fa fa-university"></i>
                      </b-input-group-text>
                      <b-form-group style="width: 100%">
                        <Select2
                          class="myselect2"
                          v-model="profile.universityId"
                          :options="universityList"
                          @select="conditionalSelect($event, 'edu')"
                          :disabled="profile.universityId == notUniversity"
                        ></Select2>
                        <b-form-input
                          trim
                          class="mt-1"
                          v-model="profile.otherUniversity"
                          v-show="profile.universityId == notUniversity"
                          placeholder="نام دانشگاه"
                          @input="reactivity = !reactivity"
                        ></b-form-input>
                      </b-form-group>
                    </b-input-group-prepend>
                  </b-form-group>
                </b-col>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                <b-col>
                  <b-form-group label="رشته تحصیلی">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="fa fa-user"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>

                      <b-form-input
                        trim
                        type="text"
                        v-model="profile.field"
                        class="form-control"
                      />
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                <b-col>
                  <b-form-group label="آخرین مدرک تحصیلی">
                    <!-- <b-form-input trim  type="text" v-model="profile.city"></b-form-input> -->
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="fa fa-book"></i>
                      </b-input-group-text>
                      <b-form-select
                        v-model="profile.lastDegree"
                        :options="eduGradeOptions"
                        @select="conditionalSelect($event, 'last')"
                      ></b-form-select>
                    </b-input-group-prepend>
                  </b-form-group>
                </b-col>
              </div>
            </b-row>
          </form>

          <hr />

          <div class="d-flex justify-content-center mb-3">
            <!-- NOTE (b-submit) to submit and save uploaded files -->
            <b-button variant="primary" @click="submit()" :disabled="busySave"
              >ذخیره</b-button
            >
          </div>
        </b-tab>
        <b-tab v-if="role == 'researcher'" :title="'فایل‌ها'">
          <b-form-group label="رزومه سوابق علمی، تخصصی،و تحقیقاتی ">
            <b-form-file
              @input="myUpload(file)"
              v-model="file"
              browse-text="بارگذاری"
              placeholder="فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)"
            ></b-form-file>
          </b-form-group>
          <b-form-group>
            <b-col>
              <b-row></b-row>
              <br />
              <b-progress
                v-if="myFile.showProgress"
                :value="myFile.uploadPercentage"
                :max="max"
                show-progress
                :animated="myFile.striped"
                :variant="myFile.variant"
                style="background-color:transparent"
              ></b-progress>
              <b-row>
                <br />
                <span v-if="myFile.isUploaded">{{ myFile.fileName }}</span>
                <div v-if="myFile.isUploaded" color="green" class="mt-5">
                  فایل با موفقیت بارگذاری شد.
                </div>
              </b-row>
            </b-col>
          </b-form-group>

          <!-- NOTE (t-files) to show added resume files on files tab -->
          <b-table
            responsive
            show-empty
            head-variant="dark"
            :fields="fileFields"
            :items="profileFiles"
            empty-text="فایلی وجود ندارد"
            striped
            :busy="fileBusy"
            :filter="fileFilter"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div style="text-align: center; vertical-align: middle">
                <b-button
                  class="btn btn-danger"
                  @click="doDelFile(data.item, data.index)"
                  target="_blank"
                  >حذف فایل</b-button
                >
              </div>
            </template>
            <template v-slot:cell(url)="data">
              <div style="text-align: center; vertical-align: middle">
                <a
                  v-if="data.value"
                  class="btn btn-success"
                  :href="data.value"
                  target="_blank"
                  >دریافت فایل</a
                >
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 }}
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>

          <!-- NOTE (b-submit) to submit and save uploaded files -->
          <b-button variant="primary" @click="submit()">ذخیره</b-button>
        </b-tab>
        <b-tab title="تغییر رمز عبور">
          <h4 varient="primary">
            پژوهشگر گرامی؛ لطفا توجه بفرمایید اگر تا بحال رمز عبور خود را تغییر
            نداده‌اید، به صورت پیشفرض رمز عبور شما همان شماره موبایل شما
            می‌باشد.
          </h4>
          <b-form-group label="رمز عبور فعلی">
            <b-form-input
              trim
              v-model="oldPassword"
              type="password"
              autocomplete="new-password"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="رمز عبور جدید">
            <b-form-input
              trim
              v-model="password"
              @input="passStrength"
              type="password"
            ></b-form-input>
            <br />
            <!--============== checking password =========== -->
            <b-row class="w-50">
              <b-col>
                <!-- NOTE check if the pass has more than 8 charector -->
                <p
                  class="pass"
                  :class="{ 'pass--passed': password.length > 7 }"
                >
                  <i
                    class="frmIcon fa"
                    :class="password.length > 7 ? 'fa-check' : 'fa-times'"
                  ></i>
                  حداقل ۸ نویسه
                </p>
              </b-col>
              <b-col>
                <!-- NOTE check if the pass has uppercase -->
                <p class="pass" :class="{ 'pass--passed': has_uppercase }">
                  <i
                    class="frmIcon fa"
                    :class="has_uppercase ? 'fa-check' : 'fa-times'"
                  ></i>
                  دارای حروف بزرگ باشد
                </p>
              </b-col>
            </b-row>
            <b-row class="w-50">
              <b-col>
                <!-- NOTE check if the pass has lowercase -->
                <p class="pass" :class="{ 'pass--passed': has_lowercase }">
                  <i
                    class="frmIcon fa"
                    :class="has_lowercase ? 'fa-check' : 'fa-times'"
                  ></i>
                  دارای حروف کوچک باشد
                </p>
              </b-col>
              <b-col>
                <!-- NOTE check if the pass has number -->
                <p class="pass" :class="{ 'pass--passed': has_number }">
                  <i
                    class="frmIcon fa"
                    :class="has_number ? 'fa-check' : 'fa-times'"
                  ></i>
                  دارای عدد باشد
                </p>
              </b-col>
            </b-row>

            <!--============== checking password =========== -->
          </b-form-group>
          <b-form-group label="تکرار رمز عبور جدید">
            <b-form-input
              trim
              v-model="repeatPassword"
              type="password"
              aria-describedby="repeat-password"
              :state="checkPassword"
            ></b-form-input>
            <b-form-invalid-feedback id="repeat-password"
              >رمز عبور با تکرار آن همخوانی ندارد</b-form-invalid-feedback
            >
          </b-form-group>
          <b-row>
            <b-col>
              <v-btn
                @click="changePassword()"
                :disabled="isBusy || checkPassword == false"
                class="blue-btn"
              >
                تغییر رمز
              </v-btn>
            </b-col>
            <b-col>
              <a
                class="text-primary"
                style="float: left; cursor: pointer"
                v-if="role != 'university'"
                @click="
                  showResetPass();
                  sendCode();
                "
                :disabled="isBusy"
                >رمز عبور خود را فراموش کرده اید؟</a
              >
            </b-col>
          </b-row>
          <!-- NOTE (b-changePass) to change the password -->
        </b-tab>
      </b-tabs>
    </b-card>
    <b-modal
      id="delColleague"
      ref="delColleague"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center"
      size="md"
    >
      <template v-slot:modal-header>
        <h4>حذف {{ selected.eduField }}</h4>
      </template>
      <template v-slot:modal-footer>
        <div v-if="role == 'researcher'">
          <b-row>
            <b-col cols="1"></b-col>
            <b-col cols="10">
              <!-- NOTE (b-doDeleteColleague) to confirm the Colleague removal -->
              <b-button variant="danger" size="lg" @click="doDeleteOffer()"
                >حذف کن</b-button
              >

              <!-- NOTE (b-doDeleteColleague) to cancel the Colleague removal -->
              <b-button
                variant="warning"
                size="lg"
                class="ml-2"
                @click="hideModal()"
                >لغو</b-button
              >
            </b-col>
            <b-col cols="1"></b-col>
          </b-row>
        </div>
      </template>
      از حذف این مورد مطمئن هستید؟
      <br />
      <br />این کار غیر قابل برگشت خواهد بود!
    </b-modal>
    <b-modal
      id="delItem"
      ref="delItem"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center"
      size="md"
    >
      <template v-slot:modal-header>
        <h4>حذف {{ selected.title }}</h4>
      </template>
      <template v-slot:modal-footer>
        <div v-if="role == 'researcher'">
          <b-row>
            <b-col cols="1"></b-col>
            <b-col cols="10">
              <!-- NOTE (b-doDeleteColleague) to confirm the Colleague removal -->
              <b-button variant="danger" size="lg" @click="doDeleteItem()"
                >حذف کن</b-button
              >

              <!-- NOTE (b-doDeleteColleague) to cancel the Colleague removal -->
              <b-button
                variant="warning"
                size="lg"
                class="ml-2"
                @click="$refs['delItem'].hide()"
                >لغو</b-button
              >
            </b-col>
            <b-col cols="1"></b-col>
          </b-row>
        </div>
      </template>
      از حذف این مورد مطمئن هستید؟
      <br />
      <br />این کار غیر قابل برگشت خواهد بود!
    </b-modal>
    <b-modal
      id="delFile"
      ref="delFile"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center"
      size="md"
    >
      <template v-slot:modal-header>
        <h5>حذف فایل {{ selected.name }}</h5>
      </template>
      <template v-slot:modal-footer>
        <div v-if="role == 'researcher'">
          <b-row>
            <b-col cols="1"></b-col>
            <b-col cols="10">
              <!-- NOTE (b-doDeleteColleague) to confirm the Colleague removal -->
              <b-button variant="danger" size="lg" @click="delFile(selected.id)"
                >حذف کن</b-button
              >

              <!-- NOTE (b-doDeleteColleague) to cancel the Colleague removal -->
              <b-button
                variant="warning"
                size="lg"
                class="ml-2"
                @click="hideDelFileModal()"
                >لغو</b-button
              >
            </b-col>
            <b-col cols="1"></b-col>
          </b-row>
        </div>
      </template>
      آیا از حذف این مورد مطمئن هستید؟
      <br />
      <br />این کار غیر قابل برگشت خواهد بود!
    </b-modal>
    <router-view></router-view>
  </div>
</template>

<script>
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
import md5 from "js-md5";
import mixin from "../mixins/utilities";
import VueCkeditor from "vue-ckeditor2";
import YearModal from "@/components/YearModal";

export default {
  mixins: [mixin],
  components: {
    Select2,
    datePicker: VuePersianDatetimePicker,
    VueCkeditor,
    YearModal,
  },
  data() {
    return {
      reactivity: false,
      hasWrongDoi: false,
      hasloading: false,
      selectedFile: "",
      selected: "",
      variable: "",
      otherUniversity: "",
      myUniversityJob: "",
      password: "",
      repeatPassword: "",
      oldPassword: "",
      newUniversity: {},
      mehvars: [],
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      role: "",
      codeSent: false,
      activationCode: "",
      newPass: "",
      repeatNewPass: "",
      countdown: 60,
      sendAgainDisbaled: false,
      busy: false,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      mediaToken: "",
      profile: {},
      isLoaded: true,
      universityList: [],
      profileFiles: [],
      universityProfile: {},
      types: [
        {
          value: "پژوهشگاه و مراکز تحقیقاتی",
          text: "پژوهشگاه و مراکز تحقیقاتی",
        },
        {
          value: "دانشگاه‌های وابسته به وزارت علوم تحقیقات فناوری",
          text: "دانشگاه‌های وابسته به وزارت علوم تحقیقات فناوری",
        },
        {
          value: "دانشگاه‌های علوم پزشکی وزارت بهداشت درمان و آموزش پزشکی",
          text: "دانشگاه‌های علوم پزشکی وزارت بهداشت درمان و آموزش پزشکی",
        },
        {
          value: "سایر",
          text: "سایر",
        },
      ],
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام فایل" },
        { key: "url", label: "دریافت" },
        { key: "operation", label: "حذف" },
      ],
      eduFields: [
        { key: "index", label: "#" },
        { key: "eduGrade", label: "درجه تحصیلی" },
        { key: "eduField", label: "رشته تحصیلی" },
        { key: "uniName", label: "نام موسسه محل تحصیل" },
        { key: "country", label: "كشور محل تحصیل" },
        { key: "year", label: "سال دریافت" },
        { key: "operation", label: "حذف" },
      ],
      mehvarFields: [
        { key: "index", label: "#" },
        { key: "mehvar_subject", label: "محور" },
        { key: "mehvarCatName", label: "موضوع" },
        { key: "mehvar_date", label: "تاریخ" },
        { key: "mehvar_contract", label: "توافقنامه" },
      ],
      articlesFields: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان مقاله" },
        { key: "publishDate", label: "تاریخ چاپ" },
        { key: "DOI", label: "DOI" },
        { key: "operation", label: "حذف" },
      ],
      inventionsFields: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان" },
        { key: "submitDate", label: "تاریخ ثبت" },
        { key: "operation", label: "حذف" },
      ],
      booksFields: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان" },
        { key: "publisher", label: "انتشارات" },
        { key: "publishDate", label: "تاریخ چاپ" },
        { key: "operation", label: "حذف" },
      ],
      grantFields: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان گرنت" },
        { key: "subject", label: "موضوع فعالیت" },
        { key: "grantYear", label: "سال انجام پژوهش" },
        { key: "operation", label: "حذف" },
      ],
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "Font",
          ],
        ],
      },
      eduGradeOptions: ["کارشناسی", "کارشناسی ارشد", "دکتری", "دکتری حرفه ای"],
      fileBusy: true,
      fileFilter: "",
      items: [],
      articles: [],
      inventions: [],
      books: [],
      grants: [],
      emailCheck: true,
      isModalVisible: false,
      iran: [],
      countries: [],
      isOtherUni: false,
      busySave: false,
      isOtherUni1: false,
      isBusy: false,
      selectedOffer: "",
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      rec_has_number: false,
      rec_has_lowercase: false,
      rec_has_uppercase: false,
      uploadedFiles: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      wrongDoi: [],
      interval: "",
      doiLoading: [],
      haveChar: [],
      errorMessage: [],
      imageFile: [],
      myImageFile: new Object({
        uploadPercentage: 0,
      }),
      profileLoading: false,
      categories: [],
      showYearModal: [],
      selectedIndex: "",
      eduReactivity: false,
      showGrantYearModal: [],
      selectedGrantIndex: "",
    };
  },
  computed: {
    checkPassword() {
      // NOTE (c-checkPass) to check that the password is not duplicate
      return this.password == this.repeatPassword ? null : false;
    },
    // NOTE this func check if the password has lowecase,uppercase and number
  },
  methods: {
    getItemYear(value) {
      this.items[this.selectedIndex].year = value;
    },
    getShowModal(value) {
      this.showYearModal[this.selectedIndex] = value;
      this.eduReactivity = !this.eduReactivity;
    },
    getGrantYear(value) {
      this.grants[this.selectedGrantIndex].grantYear = value;
    },
    getShowGrantModal(value) {
      this.showGrantYearModal[this.selectedGrantIndex] = value;
      this.eduReactivity = !this.eduReactivity;
    },
    passStrength() {
      this.has_number = /\d/.test(this.password);
      this.has_lowercase = /[a-z]/.test(this.password);
      this.has_uppercase = /[A-Z]/.test(this.password);
      this.rec_has_number = /\d/.test(this.newPass);
      this.rec_has_lowercase = /[a-z]/.test(this.newPass);
      this.rec_has_uppercase = /[A-Z]/.test(this.newPass);
    },
    checkDoi(doi, index) {
      this.wrongDoi[index] = false;
      this.haveChar[index] = false;

      // button disable condition
      if (this.wrongDoi.includes(true)) {
        this.hasWrongDoi = true;
      } else {
        this.hasWrongDoi = false;
      }
      clearInterval(this.interval);

      this.interval = setInterval(() => {
        if (doi.length > 0) {
          this.haveChar[index] = true;
          this.getArticleInfo(doi, index);
          clearInterval(this.interval);
        }
      }, 1500);
    },
    getArticleInfo(doi, index) {
      this.doiLoading[index] = true;
      // button disable condition
      if (this.doiLoading.includes(true)) {
        this.hasloading = true;
      } else {
        this.hasloading = false;
      }
      this.reactivity = !this.reactivity;
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/request/article/doi",
          { doi: doi },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.wrongDoi[index] = false;
          this.errorMessage[index] = "";
          clearInterval(this.interval);
          setTimeout(() => {
            this.doiLoading[index] = false;
            // button disable condition
            if (this.doiLoading.includes(true)) {
              this.hasloading = true;
            } else {
              this.hasloading = false;
            }
            this.reactivity = !this.reactivity;
          }, 1000);

          // button disable condition
          if (this.wrongDoi.includes(true)) {
            this.hasWrongDoi = true;
          } else {
            this.hasWrongDoi = false;
          }
        })
        .catch((err) => {
          if (err.response.status == 404 || err.response.status == 409) {
            this.wrongDoi[index] = true;
            this.errorMessage[index] = err.response.data;
            clearInterval(this.interval);
          } else {
            console.log(err);
          }
          // button disable condition
          if (this.wrongDoi.includes(true)) {
            this.hasWrongDoi = true;
          } else {
            this.hasWrongDoi = false;
          }
          if (this.doiLoading.includes(true)) {
            this.hasloading = true;
          } else {
            this.hasloading = false;
          }

          setTimeout(() => {
            this.doiLoading[index] = false;
            this.reactivity = !this.reactivity;
          }, 1000);
        });
    },
    delUni() {
      this.profile.universityJobId = "";
      if (this.profile.universityJobId == 1) {
        this.profile.universityJobOther = "";
      }
    },
    delFile(fileId) {
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/profile/removeFile",
          {
            fileId: fileId,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.showAcount();
          this.fileBusy = false;
          this.toast(res.data, "success");
          this.$bvModal.hide("loading");
          this.hideDelFileModal();
          this.file = [];
          this.myFile = new Object({
            uploadPercentage: 0,
          });
          this.isLoaded = true;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");

          if (err.response.status == 403) {
            this.$router.push("/login");
          }
        });
    },
    changePassword() {
      if (
        this.has_number &&
        this.has_lowercase &&
        this.has_uppercase &&
        this.password.length > 7
      ) {
        this.$bvModal.show("loading");
        this.isLoaded = false;
        // NOTE (m-changePassword) to change the password
        this.isBusy = true;
        if (this.role == "researcher") {
          this.$http
            .post(
              this.baseUrl + "/setad/researcher/password/changePassword",
              {
                password: md5(this.password),
                oldPassword: md5(this.oldPassword),
              },
              {
                headers: {
                  Authorization: "Bearer: " + localStorage.getItem("userId"),
                },
              }
            )
            .then((res) => {
              this.$bvModal.hide("loading");
              this.isLoaded = true;
              this.isBusy = false;
              this.password = "";
              this.repeatPassword = "";
              this.oldPassword = "";
              this.has_uppercase = false;
              this.has_lowercase = false;
              this.has_number = false;
              this.toast(res.data, "success");
            })
            .catch((err) => {
              this.$bvModal.hide("loading");
              this.isLoaded = true;
              this.isBusy = false;
              console.log(err);
              this.toast(err.response.data, "error");
            });
        } else if (this.role == "referee") {
          this.isBusy = true;
          this.$http
            .post(
              this.baseUrl + "/setad/reviewer/password/changePassword",
              {
                password: md5(this.password),
                oldPassword: md5(this.oldPassword),
              },
              {
                headers: {
                  Authorization: "Bearer: " + localStorage.getItem("userId"),
                },
              }
            )
            .then((res) => {
              this.isBusy = false;
              this.toast(res.data, "success");
              this.$bvModal.hide("loading");
            })
            .catch((err) => {
              this.isBusy = false;
              console.log(err);
              this.toast(err.response.data, "error");
              this.$bvModal.hide("loading");
            });
        } else if (this.role == "university") {
          this.isBusy = true;
          this.$http
            .post(
              this.baseUrl + "/setad/university/uniResetPassword",
              {
                password: md5(this.password),
                oldPassword: md5(this.oldPassword),
              },
              {
                headers: {
                  Authorization: "Bearer: " + localStorage.getItem("userId"),
                },
              }
            )
            .then((res) => {
              this.isBusy = false;
              this.toast(res.data, "success");
              this.$bvModal.hide("loading");
              this.password = "";
              this.repeatPassword = "";
              this.oldPassword = "";
              this.has_uppercase = false;
              this.has_lowercase = false;
              this.has_number = false;
            })
            .catch((err) => {
              this.isBusy = false;
              console.log(err);
              this.toast(err.response.data, "error");
              this.$bvModal.hide("loading");
            });
        }
      } else {
        this.toast(
          "لطفا جهت حفظ امنیت اطلاعات خود موارد خواسته شده را در رمز خود اعمال کنید",
          "error"
        );
      }
    },
    toHHMMSS(value) {
      // NOTE (m-toHHMMSS) determine the order of hours, minutes and seconds
      var sec_num = parseInt(value, 10); // don't forget the second param
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - hours * 3600) / 60);
      var seconds = sec_num - hours * 3600 - minutes * 60;

      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return minutes + ":" + seconds;
    },
    countDownTimer() {
      //NOTE (m-countDownTimer) to start counting down after 1 second
      if (this.countdown > 0) {
        setTimeout(() => {
          this.countdown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    showResetPass() {
      this.$refs["resetPassModal"].show();
    },
    closeResetPass() {
      this.$refs["resetPassModal"].hide();
      this.activationCode = "";
      this.newPass = "";
      this.repeatNewPass = "";
      this.codeSent = false;
    },
    sendCode() {
      // NOTE (m-sendCode) to send the code
      this.codeSent = false;
      this.busy = true;
      if (this.role == "researcher") {
        this.$http
          .post(
            this.baseUrl + "/setad/researcher/password/resSenCode",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.codeSent = true;
            this.busy = false;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.busy = false;
          });
      } else if (this.role == "referee") {
        this.$http
          .post(
            this.baseUrl + "/setad/reviewer/password/resSenCode",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then(() => {
            this.codeSent = true;
            this.busy = false;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.busy = false;
          });
      }
    },
    resetPass() {
      if (
        this.rec_has_number &&
        this.rec_has_lowercase &&
        this.rec_has_uppercase &&
        this.newPass.length > 7
      ) {
        if (this.newPass == this.repeatNewPass) {
          this.busy = true;
          if (this.role == "researcher") {
            this.$http
              .post(
                this.baseUrl + "/setad/researcher/password/changePasswordSms",
                {
                  password: md5(this.newPass),
                  activationCode: this.activationCode,
                },
                {
                  headers: {
                    Authorization: "Bearer: " + localStorage.getItem("userId"),
                  },
                }
              )
              .then((res) => {
                this.toast(res.data, "success");
                this.busy = false;
                this.$refs["resetPassModal"].hide();
                this.activationCode = "";
                this.newPass = "";
                this.repeatNewPass = "";
              })
              .catch((err) => {
                console.log(err);
                this.toast(err.response.data, "error");
                this.busy = false;
              });
          } else if (this.role == "referee") {
            this.$http
              .post(
                this.baseUrl + "/setad/reviewer/password/changePasswordSms",
                {
                  password: md5(this.newPass),
                  activationCode: this.activationCode,
                },
                {
                  headers: {
                    Authorization: "Bearer: " + localStorage.getItem("userId"),
                  },
                }
              )
              .then((res) => {
                this.toast(res.data, "success");
                this.busy = false;
                this.$refs["resetPassModal"].hide();
              })
              .catch((err) => {
                console.log(err);
                this.toast(err.response.data, "error");
                this.busy = false;
              });
          }
        } else {
          this.toast("رمز عبور و تکرار آن باید منطبق باشند", "error");
        }
      } else {
        this.toast(
          "لطفا جهت حفظ امنیت اطلاعات خود موارد خواسته شده را در رمز خود اعمال کنید",
          "error"
        );
      }
    },
    conditionalSelect(option, type) {
      // NOTE (m-conditionalSelect) to choose from options related to university informations
      if (option.text == "--گزینه مورد نظر خود را انتخاب نمایید--") {
        switch (type) {
          case "job":
            this.myUniversityJob = "";
            break;
          case "edu":
            this.profile.universityId = "";
            break;
          case "last":
            this.profile.lastDegree = "";
            break;
        }
      } else if (option.text == "سایر دانشگاه ها") {
        switch (type) {
          case "job":
            this.isOtherUni1 = true;
            break;
          case "edu":
            this.isOtherUni = true;
            break;
        }
      }
      this.$forceUpdate();
    },
    isEmail(email) {
      // NOTE (m-isEmail) to check the validity of the email
      return email ? (this.validateEmail(email) ? null : false) : null;
    },
    isID(id) {
      // NOTE (m-isID) to check the validity of the national code
      return id ? (this.checkCodeMeli(id) ? null : false) : null;
    },
    hideModal() {
      // NOTE (modal) to hide modal
      this.$refs["delColleague"].hide();
    },
    hideDelFileModal() {
      // NOTE (modal) to hide modal
      this.$refs["delFile"].hide();
    },
    addOffer() {
      // NOTE (m-addOffer) to add Educational and professional qualifications
      this.items.push({
        eduGrade: "",
        eduField: "",
        uniName: "",
        country: "",
        year: "",
        operation: "",
      });
    },
    addItem(variable) {
      this[variable].push({});
      if (variable == "articles") {
        this.wrongDoi.push(false);
        this.haveChar.push(false);
        this.doiLoading.push(false);
        this.errorMessage.push("");
        // button disable condition
        if (this.wrongDoi.includes(true)) {
          this.hasWrongDoi = true;
        } else {
          this.hasWrongDoi = false;
        }
      }
    },
    delOffer(offer, index) {
      this.selectedOffer = index;
      this.selected = offer;
      this.$refs["delColleague"].show();
    },
    delItem(variable, item, index) {
      this.variable = variable;
      this.selected = item;
      this.selectedFile = index;
      this.$refs["delItem"].show();
    },
    doDelFile(file, index) {
      this.selectedOffer = index;
      this.selected = file;
      this.$refs["delFile"].show();
    },
    doDeleteOffer() {
      // NOTE (m-deleteColleague) to remove the selected colleague
      this.items.splice(this.selectedOffer, 1);
      // this.$refs["delColleague"].hide();
      this.$bvModal.hide("delColleague");
    },
    doDeleteItem() {
      this[this.variable].splice(this.selectedFile, 1);
      if (this.variable == "articles") {
        this.wrongDoi.splice(this.selectedFile, 1);
        this.haveChar.splice(this.selectedFile, 1);
        this.doiLoading.splice(this.selectedFile, 1);
        this.errorMessage.splice(this.selectedFile, 1);
        // button disable condition
        if (this.wrongDoi.includes(true)) {
          this.hasWrongDoi = true;
        } else {
          this.hasWrongDoi = false;
        }
        if (this.doiLoading.includes(true)) {
          this.hasloading = true;
        } else {
          this.hasloading = false;
        }
      }
      this.$bvModal.hide("delItem");
    },
    submit() {
      if (this.validateEmail(this.profile.email) || this.profile.email == "") {
        if (
          this.checkCodeMeli(this.profile.natCode) ||
          this.profile.natCode == ""
        ) {
          this.$bvModal.show("loading");
          this.isLoaded = false;
          this.busySave = true;
          // NOTE (m-submit) to confirm the edits made
          if (this.role == "researcher") {
            this.$http
              .post(
                this.baseUrl + "/setad/researcher/profile/edit",
                {
                  name: this.profile.name,
                  lastName: this.profile.lastName,
                  email: this.profile.email,
                  fax: this.profile.fax,
                  natCode: this.profile.natCode,
                  lastDegree: this.profile.lastDegree,
                  universityId: this.profile.universityId,
                  stateId: this.profile.stateId ? this.profile.stateId : null,
                  cityId: this.profile.cityId ? this.profile.cityId : null,
                  files: this.profileFiles,
                  homePhone: this.profile.homePhone,
                  officePhone: this.profile.officePhone,
                  fax: this.profile.fax,
                  address: this.profile.address,
                  universityJobId: this.profile.universityJobId,
                  universityJobOther:
                    this.profile.universityJobId == this.notUniversity
                      ? this.profile.universityJobOther
                      : "",
                  universityOther:
                    this.profile.universityId == this.notUniversity
                      ? this.profile.universityOther
                      : "",
                  educationDetails: this.items,
                  doneActivities: this.profile.isDistinguished
                    ? this.profile.doneActivities
                    : undefined,
                  inProgressActivities: this.profile.isDistinguished
                    ? this.profile.inProgressActivities
                    : undefined,
                  articles: this.profile.isDistinguished
                    ? this.articles
                    : undefined,
                  inventions: this.profile.isDistinguished
                    ? this.inventions
                    : undefined,
                  books: this.profile.isDistinguished ? this.books : undefined,
                  grants: this.profile.isDistinguished
                    ? this.grants
                    : undefined,
                  website: this.profile.website,
                  catId: this.profile.isDistinguished
                    ? this.profile.catId
                    : undefined,
                },
                {
                  headers: {
                    Authorization: "Bearer: " + localStorage.getItem("userId"),
                  },
                }
              )
              .then((res) => {
                this.$bvModal.hide("loading");
                this.isLoaded = true;
                // this.$store.state.username = this.profile.name;
                localStorage.setItem("username", this.profile.name);
                this.toast(res.data, "success");
                this.busySave = false;
                this.showAcount();
              })
              .catch((err) => {
                this.$bvModal.hide("loading");
                this.isLoaded = true;
                console.log(err);
                this.toast(err.response.data, "error");
                this.busySave = false;
              });
          } else if (this.role == "referee") {
            this.$http
              .post(
                this.baseUrl + "/setad/reviewer/profile/edit",
                {
                  name: this.profile.name,
                  lastName: this.profile.lastName,
                  email: this.profile.email,
                  natCode: this.profile.natCode,
                  lastDegree: this.profile.lastDegree,
                  universityId: this.profile.universityId,
                  otherUniversity:
                    this.profile.universityId == this.notUniversity
                      ? this.profile.otherUniversity
                      : "",
                  stateId: this.profile.stateId ? thus.profile.stateId : null,
                  cityId: this.profile.cityId ? thus.profile.cityId : null,
                  field: this.profile.field,
                },
                {
                  headers: {
                    Authorization: "Bearer: " + localStorage.getItem("userId"),
                  },
                }
              )
              .then((res) => {
                this.$bvModal.hide("loading");
                // this.$store.state.username = this.profile.name;
                localStorage.setItem(
                  "username",
                  this.profile.name + " " + this.profile.lastName
                );

                this.toast(res.data, "success");
                this.busySave = false;
                setTimeout(() => {
                  this.showAcount();
                }, 300);
              })
              .catch((err) => {
                this.$bvModal.hide("loading");
                console.log(err);
                this.toast(err.response.data, "error");
                this.busySave = false;
              });
          } else if (this.role == "university") {
            this.$http
              .post(
                this.baseUrl + "/setad/university/editProfile",
                {
                  ...this.newUniversity,
                  description: JSON.stringify(this.universityProfile),
                },
                {
                  headers: {
                    Authorization: "Bearer: " + localStorage.getItem("userId"),
                  },
                }
              )
              .then((res) => {
                this.isBusy = false;
                this.busySave = false;
                this.toast(res.data, "success");
                this.$bvModal.hide("loading");
              })
              .catch((err) => {
                this.isBusy = false;
                this.busySave = false;
                console.log(err);
                this.toast(err.response.data, "error");
                this.$bvModal.hide("loading");
              });
          }
        } else {
          this.toast("کدملی وارد شده صحیح نمی باشد", "error");
        }
      } else {
        if (
          this.checkCodeMeli(this.profile.natCode) ||
          this.profile.natCode == ""
        ) {
          this.toast("پست الکترونیکی وارد شده صحیح نمی باشد", "error");
        } else {
          this.toast("کدملی و پست الکترونیکی وارد شده صحیح نمی باشند", "error");
        }
      }
    },
    myUpload(file) {
      // NOTE (m-myUpload) to upload files
      this.myFile.showProgress = true;
      this.myFile.variant = "info";
      this.myFile.uploadPercentage = 0;
      this.myFile.isUploaded = false;
      this.myFile.uploadButDisable = true;
      var formData = new FormData();
      formData.append(file.name, file);

      this.$http
        .post(this.baseUrl + "/setad/researcher/profile/addFile", formData, {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
          onUploadProgress: ((progressEvent) => {
            this.myFile.uploadPercentage =
              Math.round((progressEvent.loaded * 100) / progressEvent.total) -
              1;
          }).bind(this),
        })
        .then((d) => {
          if (d.status == 200) {
            this.myFile.isUploaded = true;
            this.myFile.uploadPercentage = 100;
            this.myFile.striped = false;
            this.myFile.variant = "success";
            this.myFile.uploadButDisable = false;
            this.profile.files.push(d.data);
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    uploadProfile(file) {
      if (!file) {
        return;
      }
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد.", "error");
        return;
      } else {
        // NOTE (m-myUpload) to upload files
        this.myImageFile.showProgress = true;
        this.myImageFile.variant = "info";
        this.myImageFile.uploadPercentage = 0;
        this.myImageFile.isUploaded = false;
        this.myImageFile.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);
        this.profileLoading = true;
        this.$http
          .post(this.baseUrl + "/setad/researcher/profile/avatar", formData, {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
            onUploadProgress: ((progressEvent) => {
              this.myImageFile.uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          })
          .then((d) => {
            if (d.status == 200) {
              this.myImageFile.isUploaded = true;
              this.myImageFile.uploadPercentage = 100;
              this.myImageFile.striped = false;
              this.myImageFile.variant = "success";
              this.myImageFile.uploadButDisable = false;
              this.profile.avatar = d.data;
              this.profileLoading = false;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.profileLoading = false;
          });
      }
    },
    showAcount() {
      if (this.role == "researcher") {
        this.$http
          .post(
            this.baseUrl + "/setad/researcher/profile/getInfo",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.profile = res.data;
            this.articles = res.data.articles;
            this.books = res.data.books;
            this.inventions = res.data.inventions;
            this.grants = res.data.grants;
            this.items = res.data.educationDetails;
            this.profileFiles = this.profile.files;
            //try {
            //  this.profileFiles = this.profile.files;
            //} catch (error) {
            //  this.profileFiles = [];
            //}
            this.profile.isDistinguished ? this.getCats() : "";
            this.fileBusy = false;

            this.$bvModal.hide("loading");
            this.isLoaded = true;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");

            if (err.response.status == 403) {
              this.$router.push("/login");
            }
          });
        this.$bvModal.hide("loading");
        this.isLoaded = true;
      } else if (this.role == "referee") {
        this.$http
          .post(
            this.baseUrl + "/setad/reviewer/profile/getInfo",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.profile = res.data;
            this.fileBusy = false;
            this.$bvModal.hide("loading");
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");

            if (err.response.status == 403) {
              this.$router.push("/login");
            }
          });
        this.$bvModal.hide("loading");
      }
    },
    onMounted() {
      this.showAcount();
      // NOTE (MOUNTED) to show profile page details
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.$http
        .post(
          this.baseUrl + "/setad/" + this.role + "/allUniversities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universityList = res.data;
          this.universityList.push(
            new Object({
              id: 1,
              text: "سایر دانشگاه ها",
            })
          );
          this.universityList.unshift({
            id: 0,
            text: "--گزینه مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });
          this.$bvModal.hide("loading");
          this.isLoaded = true;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.$bvModal.hide("loading");
          this.isLoaded = true;
        });
    },
    getStatesAndCities() {
      this.$http
        .get(this.baseUrl + "/setad/options/states/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.iran = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getCountries() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/countries",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.countries = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getCats() {
      this.$http
        .post(
          this.baseUrl + "/setad/public/categories/list",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.categories = [];
          this.categories.push(
            ...res.data.map((x) => {
              return {
                code: x.id,
                label: x.name,
              };
            })
          );
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
  },
  watch: {
    codeSent: function (val, oldVal) {
      // NOTE (w-codeSent) to give the code again after 60 second
      this.countdown = 60;

      if (val == true) {
        this.sendAgainDisbaled = true;
        this.countDownTimer();
      }
    },
    countdown: function (val, oldVal) {
      // NOTE (w-countdown) to countdown for sending code again
      if (val == 0) {
        this.sendAgainDisbaled = false;
      } else {
        this.sendAgainDisbaled = true;
      }
    },
  },
  mounted() {
    this.role = localStorage.getItem("role");
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
    this.getStatesAndCities();
    this.getCountries();
    this.onMounted();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #d6bbc0;
  border-bottom: 1px solid #c8ced3;
}
.color {
  background-color: #0c4961;
  color: white;
}
.myselect2 {
  width: 100%;
}
.vs__dropdown-menu li {
  direction: rtl !important;
}
/* pass validation style */
.pass {
  font-size: 13px;
}
.pass--passed {
  color: #717b85;
}
.frmIcon {
  color: #eb0029;
}
.pass--passed .frmIcon {
  color: #0fa140;
}
.other-row {
  margin-bottom: 7px;
}
.img-box {
  border-radius: 10px;
  margin-bottom: 15px;
  margin-right: 15px;
  position: relative;
  overflow: hidden;
  width: 170px;
  height: 170px;
  border: none;

  &:hover {
    background-color: black !important;
    .img {
      opacity: 0.7;
    }

    .img-icon {
      display: block;
    }
  }

  .img {
    opacity: 1;
    width: 100%;
    height: 100%;
  }
  .img-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: none;
  }
  .img-loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #3a82b539;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
.uploadPercentage {
  position: absolute;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background-color: rgba(19, 18, 18, 0.726);
  text-align: center;
  z-index: 70;
  padding: 10px;
  span {
    color: whitesmoke;
    margin: auto;
    font-size: 1rem;
  }
}
</style>
